<header class="head">        
            <div class="d-flex align-items-center justify-content-start">
                <app-user-profile class="d-flex align-items-center my-lg-0 me-auto text-white text-decoration-none"></app-user-profile>
                <ul class="nav col-auto d-flex align-items-center justify-content-center my-md-0 text-small" style="gap: 12px;">
                    <li>
                        <app-rules-game></app-rules-game>
                    </li>
                    <li>
                        <app-select-language class="d-flex align-items-center justify-content-center struct-select"/>
                    </li>
                    <li>
                        <div class="line-menu"></div>
                    </li>
                    <li>
                        <app-exit-game />
                    </li>

                    <!-- <li>
                        Время простоя: {{ downtime.val() }}
                    </li> -->
                </ul>
            </div>
     
</header>
